import {AfterViewInit, Component, OnInit} from '@angular/core';
import {HttpService} from '../../services/http.service';
import {SweetUtil} from '../commons/sweet/sweet-util-service';
import {AuthService} from '../../auth/auth.service';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit, AfterViewInit {
  fileListJson: any;
  delCategory = '';
  categoryInput: HTMLInputElement;
  addButton: HTMLButtonElement;
  deleteButton: HTMLButtonElement;
  categorySelect: HTMLSelectElement;

  constructor(private http: HttpService, private authService: AuthService, private sweetUtil: SweetUtil ) {
  }

  ngOnInit(): void {
    this.readAllWarrantyConditionsFiles();
  }

  ngAfterViewInit() {
    this.initializeListeners();
  }
  initializeListeners() {
    this.categoryInput = document.getElementById('category-add-input') as HTMLInputElement;
    this.addButton = document.getElementById('category-add-button') as HTMLButtonElement;
    this.deleteButton = document.getElementById('category-delete-button') as HTMLButtonElement;
    this.categorySelect = document.getElementById('category-delete-select') as HTMLSelectElement;
    this.addButton.disabled = true;
    this.deleteButton.disabled = true;

    this.categoryInput.addEventListener('input', () => {
      this.addButton.disabled = this.categoryInput.value.length <= 0;
    });

    this.categorySelect.addEventListener('change', () => {
      this.deleteButton.disabled = this.categorySelect.value.length <= 0;
    });
  }

  reload() {
    window.location.reload();
  }

  readAllWarrantyConditionsFiles(){
    this.http.readWarrantyConditionBooklets().subscribe((res) => {
      this.fileListJson =  res;
      });
  }

  showForm() {
    (document.getElementById('hide') as HTMLSpanElement).className = 'show-me';
  }

  createCategory() {
    SweetUtil.getConfirm('Create', 'Create category ' + this.categoryInput.value.toUpperCase() + `?`)
      .then((res) => {
        if (res.value) {
          this.http.createWarrantyConditionsCategory(this.categoryInput.value).subscribe((r: any) => {
              SweetUtil.showSuccess(`${this.categoryInput.value.toUpperCase()} created successful.`).then(() => {
                this.reload();
              });
            },
            () => {
              this.sweetUtil.showError('Create category unsuccessful').then();
            });
        }
      });
  }

  showDeleteForm() {
    (document.getElementById('delete-hide') as HTMLSpanElement).className = 'show-me';
  }

  deleteCategory() {
    SweetUtil.getConfirm('Delete', 'Delete category ' + this.delCategory.toUpperCase() + `?`)
      .then((res) => {
        if (res.value) {
          this.http.deleteWarrantyConditionsFolder(this.delCategory).subscribe((r: any) => {
              SweetUtil.showSuccess(`${this.delCategory.toUpperCase()} deleted successful.`).then(() => {
                this.reload();
              });
            },
            () => {
              this.sweetUtil.showError('Delete category unsuccessful').then();
            });
        }
      });
  }

  isAdmin(): boolean {
    return this.authService.isAdmin();
  }

  isAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }

}
